module.exports = __webpack_public_path__ + "img/login_top_bg.c9de4e0c.png";